export namespace InputFilters {
  export const integer = /\d*/;
  export const numeric = /[-0-9., ]*/;
};
